// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"670a95e9cbea091ee943","655":"bd51370b787f7bd123e4"}[chunkId] + ".js";
};